import { render, staticRenderFns } from "./EditorOutline.vue?vue&type=template&id=36cda72a&scoped=true"
import script from "./EditorOutline.vue?vue&type=script&lang=js"
export * from "./EditorOutline.vue?vue&type=script&lang=js"
import style0 from "./EditorOutline.vue?vue&type=style&index=0&id=36cda72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cda72a",
  null
  
)

export default component.exports